import {
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  makeStyles,
  ButtonGroup,
  Paper,
  IconButton,
  TextField,
  Typography,
  Stepper,
  Step,
  StepLabel,
  Dialog,
  Chip,
  TableContainer,
  TableBody,
  Table,
  TableRow,
  TableCell,
} from "@material-ui/core";
import { countries, countryToFlag } from "../api/countries";
import { States}  from "../api/states";
import { format } from "date-fns";
import { Fragment } from "react";
import { Close } from "@material-ui/icons";
import { KeyboardTimePicker } from "@material-ui/pickers";
import { KeyboardDatePicker } from "@material-ui/pickers";
import PlacePicker from "./PlacePicker";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import MultiFileUpload from "./MultiFileUpload";
import { useConfirm } from "material-ui-confirm";
import { useInput } from "../utils/useInputHook";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";
import config from "../config";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useEffect, useState } from "react";
import { addBranch, updateBranch } from "../api/branches";
import Autocomplete from "@material-ui/lab/Autocomplete";
import formatLocation from "../utils/formatLocation";
import { useAlert } from "react-alert";
import { fetchBranchTraits } from "../api/categories";
import { getDefaultValueByWidgetType } from "./InputWidgets";
import WidgetComponent from "./WidgetComponent";
import Tooltip from "@material-ui/core/Tooltip";
import AddOpeningHourComponent from "./AddOpeningHour";
import ImageGrid from "./ImageGrid";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1, 0),
    },
  },
  heading: {
    margin: theme.spacing(1, 0, 2, 0),
  },
  previewWrapper: {
    position: "relative",
    "&  button": {
      position: "absolute",
      top: "0",
      right: "0",
    },
  },
  preview: {
    width: 100,
    height: 100,
    borderRadius: 4,
    margin: theme.spacing(0.5),
  },
  uploadSelect: {
    margin: theme.spacing(0.5),
    width: 100,
    height: 100,
  },
  phoneInput: {
    width: "100% !important",
    "&:focus": {
      borderColor: `${theme.palette.primary.main} !important`,
      boxShadow: `0 0 0 1px ${theme.palette.primary.main} !important`,
    },
  },
  option: {
    fontSize: 15,
    "& > span": {
      marginRight: 10,
      fontSize: 18,
    },
  },
  chipGroup: {
    border: "1px solid #ccc",
    padding: theme.spacing(1, 0),
    minHeight: 100,
    display: "flex",
    flexWrap: "wrap",
    "& > *": {
      margin: theme.spacing(0.5),
    },
  },
}));

const DAYS = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

const getInitialActiveHours = () => {
  const retVal = {};
  DAYS.forEach((day) => {
    retVal[day] = {
      startTime: new Date(),
      endTime: new Date(),
      isClosed: ["Friday", "Saturday"].includes(day),
    };
    retVal[day].startTime?.setHours(8, 0);
    retVal[day].endTime?.setHours(18, 0);
  });
  return retVal;
};

const normalizeDate = (date) => {
  if (date == null) return date;
  return new Date(date.getTime() + date.getTimezoneOffset() * 60000);
};

const getChipMessage = (data) => {
  try {
    let startTime = "";
    if (!!data?.startTime && data.startTime !== "") {
      startTime = format(
        normalizeDate(new Date(data?.startTime?.toString())) || new Date(),
        "hh:mm a"
      );
    }
    let endTime = "";
    if (!!data?.endTime && data.endTime !== "") {
      endTime = format(
        normalizeDate(new Date(data?.endTime?.toString())) || new Date(),
        "hh:mm a"
      );
    } else {
      endTime = " 12:00 AM";
    }
    let startDate = "";
    if (!!data?.startDate && data.startDate !== "") {
      startDate = format(
        normalizeDate(new Date(data?.startDate?.toString())) || new Date(),
        "P"
      );
    }

    console.log("opening hours", data);
    let expandedMessage = "from " + startDate;
    if (data?.endDate != null) {
      console.log("Enddate", data.endDate);
      expandedMessage +=
        " till " +
        format(new Date(data?.endDate?.toString()) || new Date(), "P");
    } else {
      expandedMessage += " onwards";
    }

    return {
      expandedMessage,
      body: data.recurringDays.join(", ") + " " + startTime + ` to ${endTime}`,
    };
  } catch (e) {
    console.error(e);
    return {
      expandedMessage: "Error: Date format error",
      body: "Error: Date format error",
    };
  }
};

const getAggregatedOpeningHours = (slots) => {
  const initialState = DAYS.reduce((r, day) => {
    r[day] = [];
    return r;
  }, {});
  return slots.reduce((d, slot) => {
    try {
      let startTime = "";
      if (!!slot?.startTime && slot.startTime !== "") {
        startTime = format(
          normalizeDate(new Date(slot?.startTime?.toString())) || new Date(),
          "hh:mm a"
        );
      }
      let endTime = "";
      if (!!slot?.endTime && slot.endTime !== "") {
        endTime = format(
          normalizeDate(new Date(slot?.endTime?.toString())) || new Date(),
          "hh:mm a"
        );
      } else {
        endTime = " 12:00AM";
      }
      slot.recurringDays.forEach((day) => {
        let message = "" + startTime;
        if (endTime === "") {
          message += " onwards";
        } else {
          message += ` to ${endTime}`;
        }
        if (!d.hasOwnProperty(day)) {
          d[day] = [message];
        } else {
          d[day].push(message);
        }
      });
    } catch (e) {
      console.error(e);
    }
    return d;
  }, initialState);
};

export default function AddBranchComponent({
  providerId,
  providerInfo,
  branch,
  activities,
  user,
  onUpdate,
  onCancel,
}) {
  const classes = useStyles();
  const alert = useAlert();
  const confirm = useConfirm();
  const isEditForm = !!branch._id;
  const [currentStep, setCurrentStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const { value: name, bind: bindName } = useInput(branch?.info?.name || "");
  const { value: description, bind: bindDescription } = useInput(
    branch?.info?.description || ""
  );
  const [contact, setContact] = useState(
    branch?.info?.contact?.contact_phone_number
  );

  const { value: licenseId, bind: bindLicenseId } = useInput(
    branch?.info?.license || ""
  );
  const [licenseExpiry, setLicenseExpiry] = useState(
    branch?.info?.license_expiry_date || null
  );

  const [provider_address_check, setProviderAddressCheck] = useState(false);

  const { value: contactName, bind: bindContactName } = useInput(
    branch?.info?.contact?.contact_name || ""
  );
  const { value: contactRole, bind: bindContactRole } = useInput(
    branch?.info?.contact?.contact_role || ""
  );
  const { value: email, bind: bindEmail } = useInput(
    branch?.info?.contact?.contact_email || ""
  );
  const {
    value: addressLine1,
    bind: bindAddressLine1,
    setValue: setAddressLine1,
  } = useInput(branch?.info?.address?.address_line_1 || "");
  const {
    value: street,
    bind: bindStreet,
    setValue: setStreet,
  } = useInput(branch?.info?.address?.street || "");
  const {
    value: landmark,
    bind: bindLandmark,
    setValue: setLandmark,
  } = useInput(branch?.info?.address?.landmark || "");
  const {
    value: area,
    bind: bindArea,
    setValue: setArea,
  } = useInput(branch?.info?.address?.area || "");
  const {
    value: city,
    bind: bindCity,
    setValue: setCity,
  } = useInput(branch?.info?.address?.city || "");
  const [state, setStateValue] = useState(!!branch?.info?.address?.state ? { name: branch?.info?.address?.state } : {name:"City of London"});
  const [country, setCountry] = useState(
    !!branch?.info?.address?.country
      ? { label: branch?.info?.address?.country }
      : { label: "United Kingdom" }
  );
  const { value: zipCode, bind: bindZipCode, setValue: setZipcode, } = useInput(
    branch?.info?.address?.zip_code || ""
  );

  const [slots, setSlots] = useState(
    !!branch?.opening_hours ? branch?.opening_hours : []
  );
  const [slotModalActive, setSlotModalActive] = useState(false);
  const [selectedSlot, setSelectedSlot] = useState({});
  const [selectedSlotIndex, setSelectedSlotIndex] = useState(-1);
  const aggregatedSlots = getAggregatedOpeningHours(slots);

  const [location, setLocation] = useState(
    formatLocation(branch?.info?.address?.location)
  );
  const [mapLoading, setMapLoading] = useState(false);
  const [traits, setTraits] = useState([]);

  const [isgenericimages, setGenericImageCheck] = useState(
    branch?.generic_images_flag || false
  );

  const [imageData, setImageData] = useState(
    branch?.images?.map((i) => ({ ...i, type: "uploaded" })) ?? []
  );
  const [removedImages, setRemovedImages] = useState([]);
  const { value: notes, bind: bindNotes } = useInput(branch?.info?.notes || "");
  const { value: trait_notes, bind: bindTraitNotes } = useInput(
    branch?.trait_notes || ""
  );
  const setFilterStates = (label) => {
    const country =  countries.filter((d) => d.label == label);
    const filterStateData = States.filter((d) => (d.country_code === country[0].code));
    return filterStateData;
 };
  const [filterState, setFilterState] = useState(providerInfo?.info?.address?.country ? setFilterStates(providerInfo?.info?.address?.country) : setFilterStates("United Kingdom"));

  const onCountryChange = (value) => {
    setCountry(value);
    filterStateFun(value.code);
    setStateValue({name:''});
  };

  const filterStateFun = (countryCode) => {
    const filterStateData = States.filter((d) => 
    (d.country_code === countryCode));
    setFilterState(filterStateData);
  };

  const [selectedActivities, setSelectedActivities] = useState(
    branch.activities || []
  );

  useEffect(() => {
    // fetch traits -> set them
    if (!branch.traits || !branch.traits.length) {
      setLoading(true);
      fetchBranchTraits(user.token)
        .then((traitGroups) => {
          if (providerInfo?.info?.category?.name === "F&B / Nightlife Places") {
            traitGroups.splice(
              traitGroups.findIndex(
                ({ trait_group }) => trait_group === "Services"
              ),
              1
            );
          } else {
            traitGroups.splice(
              traitGroups.findIndex(
                ({ trait_group }) => trait_group === "Food Services"
              ),
              1
            );
          }
          // console.log(traitGroups)
          setTraits(
            traitGroups.map((traitGroup) => {
              traitGroup.traits = traitGroup.traits.map((c) => ({
                ...c,
                currentValue: getDefaultValueByWidgetType(c.widget_type),
              }));
              return traitGroup;
            })
          );
        })
        .then(() => setLoading(false));
    } else {
      console.log("Setting existing traits", branch.traits);
      //add the pre step to set colour
      setTraits(branch.traits || []);
    }
  }, [user.token, providerInfo?.info?.category?.name, branch.traits]);

  const toggleActivity = (activity) => {
    if (selectedActivities.includes(activity)) {
      setSelectedActivities(selectedActivities.filter((a) => a !== activity));
      return;
    }
    setSelectedActivities([...selectedActivities, activity]);
  };
  const handleSelectAll = () => {
    setSelectedActivities(activities.map((item) => item.activity_template_id));
  };
  const handleDeselectAll = () => {
    setSelectedActivities([]);
  };

  const onSlotUpdate = (slot) => {
    // if valid slot && and _id is set -> update the slot
    // else insert new slot
    if (selectedSlotIndex === -1) {
      setSlots((slots) => [...slots, slot]);
    } else {
      const updatedSlots = [...slots];
      updatedSlots.splice(selectedSlotIndex, 1, slot);
      setSlots(updatedSlots);
    }
    setSelectedSlot(null);
    setSelectedSlotIndex(-1);
    setSlotModalActive(false);
  };

  const onSlotEdit = (id) => () => {
    setSelectedSlotIndex(id);
    setSelectedSlot(slots[id]);
    setSlotModalActive(true);
  };
  const onSlotDelete = (index) => () => {
    // todo: confirm
    const updatedSlots = slots.filter((slot, i) => i !== index);
    setSlots(updatedSlots);
  };

  const preImageRemove = (i) => {
    return confirm({
      description: "Are you sure you want to remove this image?",
    })
      .then(() => {
        console.log("Removing image");
        return handleImageRemove(i);
      })
      .catch(() => console.log("remove image cancelled"));
  };

  const handleImageRemove = (i) => {
    if (imageData[i].type === "uploaded") {
      setRemovedImages((current) => current.concat(imageData[i].editedUri));
    }
    if (imageData.length == 1){
      setGenericImageCheck(false);
    }
    const updatedFiles = [...imageData];
    updatedFiles.splice(i, 1);
    setImageData(updatedFiles);
  };

  const handleImageAdd = (images) => {
    const newImages = images.map((image) => {
      return {
        type: "file",
        editedUri: URL.createObjectURL(image),
        originalUri: URL.createObjectURL(image),
        file: image,
        isChecked: true,
      };
    });
    setImageData((current) => current.concat(newImages));
  };

  const handleDateChange = (date) => {
    setLicenseExpiry(date);
  };

  useEffect(() => {
    const delayed = setTimeout(async () => {
      setMapLoading(true);
      console.log("stopped typing, checking location");
      try {
        const combined = [
          addressLine1,
          street,
          area,
          city,
          state?.name || "",
          country?.label || "",
          zipCode,
        ].join(",");
        const defaultAddress = [
          branch?.info?.address?.address_line_1,
          branch?.info?.address?.street,
          branch?.info?.address?.area,
          branch?.info?.address?.city,
          branch?.info?.address?.state,
          branch?.info?.address?.country,
          branch?.info?.address?.zip_code,
        ].join(",");
        if (combined === defaultAddress) {
          console.log(
            "address same => setting to saved location",
            defaultAddress,
            combined
          );
          setLocation(formatLocation(branch?.info?.address?.location));
          return;
        }
        if (combined.length < 5) return;
        console.log(`Fetching new location`, defaultAddress, combined);
        const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
          combined
        )}&key=${config.GOOGLE_MAPS_API_KEY}`;
        const req = await fetch(url);
        const data = await req.json();
        if (data.status === "OK") {
          const location = data.results[0].geometry.location;
          console.log(`Locationfound`, location);
          setLocation(location);
        } else {
          console.log("no data?", data);
          alert.show("Failed to convert address to location");
        }
      } catch (e) {
        console.log(e);
      } finally {
        setMapLoading(false);
      }
    }, 1000);
    return () => clearTimeout(delayed);
  }, [
    addressLine1,
    street,
    area,
    city,
    state,
    country,
    zipCode,
    branch,
    alert,
  ]);

  const ActivitySelector = () => {
    if (activities.length === 0) {
      return <Typography>No activities available</Typography>;
    }
    return activities.map((activity) => {
      if (activity.visibility) {
        return (
          <FormControlLabel
            label={activity.activity_name}
            key={activity.activity_name}
            control={
              <Checkbox
                checked={selectedActivities.includes(
                  activity.activity_template_id
                )}
                onChange={() => toggleActivity(activity.activity_template_id)}
                name={activity.activity_name}
              />
            }
          />
        );
      }
      return null;
    });
  };
  const handleSubmit = async () => {
    const newFiles = imageData.filter((u) => u.type === "file").map((u) => u.file);

    const data = {
      name,
      description,
      contact_email: email,
      contact_phone_number: contact,
      contact_name: contactName,
      contact_role: contactRole,
      activities: selectedActivities,
      license: licenseId,
      license_expiry_date: licenseExpiry,
      addressLine1,
      street,
      landmark,
      area,
      city,
      state: state.name,
      country: country.label,
      notes,
      opening_hours: JSON.stringify(slots),
      traits: JSON.stringify(traits),
      trait_notes,
      zip_code: zipCode,
      latitude: location?.lat,
      longitude: location?.lng,
      images: newFiles,
      visibility: true,
      removedImages,
      isgenericimages,
      imageAttributes: JSON.stringify(
        imageData.map((item, i) => ({ ...item, order: i }))
      ),
    };
    console.log(data)

    try {
      setLoading(true);
      if (isEditForm) {
        const updated = await updateBranch(
          providerId,
          { _id: branch._id, ...data },
          user.token
        );
        onUpdate(updated);
        onCancel();
        return;
      }
     
      // create requires location
      if (!location || !location.lat || !location.lng) {
        alert.show("Please pick a location on map");
        return;
      }
      const updated = await addBranch(providerId, data, user.token);
      onUpdate(updated);
      onCancel();
    } catch (e) {
      console.error(e);
      alert.show("Failed to update");
      onCancel();
    } finally {
      setLoading(false);
    }
  };

  const UploadImages = () => {
    // returning array so that the elements would be siblings
    return (
      <>
        <Grid item xs={12} key="add-branch-image-header">
          <Typography variant="h6">Images</Typography>
        </Grid>
        <Grid item xs={12}>
            <FormControlLabel
                label="Generic Images"
                control={
                  <Checkbox
                    checked={isgenericimages}
                    disabled={imageData.length < 1}
                    onChange={() => setGenericImageCheck(!isgenericimages)}
                />
                }
              />
        </Grid>
        <Grid item xs={12} key="add-branch-image-wrapper">
          <ImageGrid
            images={imageData}
            setGridData={setImageData}
            preImageRemove={preImageRemove}
          />
          <MultiFileUpload onAdd={handleImageAdd} />
        </Grid>
      </>
    );
  };

  const onPrevClick = () => {
    setCurrentStep((currentStep) => Math.max(currentStep - 1, 0));
  };

  const progressStep = () => {
    if (currentStep === 0) {
      // validate
      if (!name) {
        alert.show("Name is required");
        return;
      }
      if (!email) {
        alert.show("Email is required");
        return;
      }
      if (!description) {
        alert.show("Description is required");
        return;
      }
      if (!contactName) {
        alert.show("Contact name is required");
        return;
      }
      if (!contact) {
        alert.show("Contact is required");
        return;
      }
      if (!contactRole) {
        alert.show("Contact role is required");
        return;
      }
      if (!addressLine1) {
        alert.show("Address is required");
        return;
      }
      if (!area) {
        alert.show("Area is required");
        return;
      }
      if (!state) {
        alert.show("State is requried");
        return;
      }
      if (!!licenseExpiry && licenseExpiry < new Date()) {
        alert.show("License can't have expiry date in past");
        return;
      }
      setCurrentStep(1);
      return;
    }
    if (currentStep === 1) {
      // todo: validate
      setCurrentStep(2);
      return;
    }
    if (currentStep === 2) {
      // todo: validate
      setCurrentStep(3);
      return;
    }
    if (currentStep === 3) {
      // todo: validate
      handleSubmit();
      return;
    }
  };

  const setAddress = (checked) => {
    if (checked) {
      setAddressLine1(providerInfo?.info?.address?.address_line_1 || "");
      setStreet(providerInfo?.info?.address?.street || "");
      setLandmark(providerInfo?.info?.address?.landmark || "");
      setArea(providerInfo?.info?.address?.area || "");
      setCity(providerInfo?.info?.address?.city || "");
      setStateValue(!!providerInfo?.info?.address?.state ? {name : providerInfo?.info?.address?.state } : { name: "" } );
      setCountry(
        !!providerInfo?.info?.address?.country
          ? { label: providerInfo?.info?.address?.country }
          : { label: "United Kingdom" }
      );
      setZipcode(providerInfo?.info?.address?.zip_code || "");
    } else {
      setAddressLine1(branch?.info?.address?.address_line_1 || "");
      setStreet(branch?.info?.address?.street || "");
      setLandmark(branch?.info?.address?.landmark || "");
      setArea(branch?.info?.address?.area || "");
      setCity(branch?.info?.address?.city || "");
      setStateValue(!!branch?.info?.address?.state ? {name : branch?.info?.address?.state } : { name: "" } );
      setCountry(
        !!branch?.info?.address?.country
          ? { label: branch?.info?.address?.country }
          : { label: "United Kingdom" }
      );
      setZipcode(branch?.info?.address?.zip_code || "");
    }
  };

  const StepOne = () => {
    return (
      <>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Name *"
            variant="outlined"
            {...bindName}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Contact Email *"
            variant="outlined"
            {...bindEmail}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            label="Contact Name *"
            variant="outlined"
            {...bindContactName}
          />
        </Grid>
        <Tooltip
          title={
            <span style={{ whiteSpace: "pre-line" }}>
              {
                "Mobile numbers: +44 followed by 10 numbers (0 excluded) \n Landline numbers: +44 followed by 10 numbers (0 excluded)"
              }
            </span>
          }
          placement="bottom-start"
        >
          <Grid item xs={12} md={4}>
            <PhoneInput
              enableSearch
              value={contact}
              containerStyle={{ margin: "8px 0" }}
              inputClass={classes.phoneInput}
              onChange={setContact}
              specialLabel="Contact Number *"
              inputProps={{ maxLength: 16 }}
              country={"gb"}
            />
          </Grid>
        </Tooltip>
        <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            label="Contact role *"
            variant="outlined"
            {...bindContactRole}
          />
        </Grid>
        <Tooltip
          title={
            <span style={{ whiteSpace: "pre-line" }}>
              {"Please try to limit the description to 3 lines"}
            </span>
          }
          placement="bottom-start"
        >
          <Grid item xs={12} md={12}>
            <TextField
              fullWidth
              label="Description *"
              multiline={true}
              rows={2}
              variant="outlined"
              {...bindDescription}
            />
          </Grid>
        </Tooltip>
        <Grid item xs={12}>
          <Typography variant="h6">Trade License Information</Typography>
        </Grid>
        <Grid item xs={6}>
          <TextField
            fullWidth
            label="Trade License ID"
            variant="outlined"
            {...bindLicenseId}
          />
        </Grid>
        <Grid item xs={6}>
          <KeyboardDatePicker
            fullWidth
            minDate={new Date()}
            minDateMessage="License can't have expiry date in past"
            inputVariant="outlined"
            variant="dialog"
            format="dd/MM/yyyy"
            label="Expiry date"
            value={licenseExpiry}
            onChange={handleDateChange}
          />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h6">Branch Address</Typography>
        </Grid>
        <Grid item xs={12}>
          <Grid item>
            <FormControlLabel
              label="Same as the company/provider address"
              control={
                <Checkbox
                  checked={provider_address_check}
                  onChange={async (event) => {
                    setProviderAddressCheck(event.target.checked);
                    setAddress(event.target.checked);
                  }}
                />
              }
            />
          </Grid>
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            disabled={provider_address_check}
            fullWidth
            label="Office No - Floor - Building Name *"
            variant="outlined"
            {...bindAddressLine1}
          />
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <TextField
                disabled={provider_address_check}
                fullWidth
                label="Street No - Street Name"
                variant="outlined"
                {...bindStreet}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                disabled={provider_address_check}
                fullWidth
                label="Landmark"
                variant="outlined"
                {...bindLandmark}
              />
            </Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <TextField
                disabled={provider_address_check}
                fullWidth
                label="Area *"
                variant="outlined"
                {...bindArea}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                disabled={provider_address_check}
                fullWidth
                label="City"
                variant="outlined"
                {...bindCity}
              />
            </Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              {/* <TextField fullWidth label="State *" variant="outlined" {...bindState} /> */}
              <Autocomplete
                id="State"
                options={filterState}
                classes={{ option: classes.option, }}
                getOptionLabel={(option) => option.name}
                fullWidth
                disabled={provider_address_check}
                autoHighlight
                disableClearable
                value={state}
                renderOption={(option) => (
                    <Fragment>
                        {option.name}
                    </Fragment>
                )}
                onChange={(e, val) => setStateValue(val)}
                renderInput={(params) => (
                  <TextField {...params} label="State *" variant="outlined" />
                )}
              />
            </Grid>
            <Grid item xs={6}>
              <Autocomplete
                id="country-select"
                disabled={provider_address_check}
                options={countries}
                classes={{
                  option: classes.option,
                }}
                autoHighlight
                disableClearable
                getOptionLabel={(option) => option.label}
                value={country}
                onChange={(e, option) => setCountry(option)}
                renderOption={(option) => (
                  <Fragment>
                    <span>{countryToFlag(option.code)}</span>
                    {option.label} ({option.code})
                  </Fragment>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    label="Country *"
                    variant="outlined"
                    inputProps={{
                      ...params.inputProps,
                      autoComplete: "new-password", // disable autocomplete and autofill
                    }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={6}>
                <TextField 
                disabled={provider_address_check}
                fullWidth
                label="Postcode" 
                variant="outlined" 
                {...bindZipCode} />
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <PlacePicker
            loading={mapLoading}
            location={location}
            onChange={setLocation}
          />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h6" style={{ flex: "1" }}>
            Notes
          </Typography>
        </Grid>
        <Tooltip
          title={
            <span style={{ whiteSpace: "pre-line" }}>
              {
                "Please use this field if there is any additional information from the provider"
              }
            </span>
          }
          placement="bottom-start"
        >
          <Grid item xs={12}>
            <TextField
              fullWidth
              multiline
              rows={2}
              label="Additional information"
              variant="outlined"
              {...bindNotes}
            />
          </Grid>
        </Tooltip>
      </>
    );
  };

  const StepTwo = () => {
    return (
      <>
        <Grid item xs={12} style={{ display: "flex", alignItems: "center" }}>
          <Typography variant="h6" style={{ marginRight: "10px", flex: "1" }}>
            Opening hours
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={1} alignItems="center" justify="center">
            <Grid item xs={12}>
              <TableContainer>
                <Table>
                  <TableBody>
                    {Object.keys(aggregatedSlots).map((day) => (
                      <TableRow key={day}>
                        <TableCell style={{ border: 0, padding: "8px 16px" }}>
                          <Typography variant="subtitle2">{day}</Typography>
                        </TableCell>
                        <TableCell style={{ border: 0, padding: "8px 16px" }}>
                          {aggregatedSlots[day].length === 0
                            ? "Closed"
                            : aggregatedSlots[day].join(" , ")}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        </Grid>
        <Grid container xs={12} alignItems="center" spacing={1}>
          <Grid item xs={7}>
            <Typography variant="h6"> Opening hours - Editor</Typography>
          </Grid>
          <Grid item xs>
            <Typography variant="h6"> </Typography>
          </Grid>
          <Tooltip
            title={
              "Please add the opening hours by clicking on this buttion and you can see the changes accordingly above"
            }
          >
            <Grid item xs justifyContent="flex-end">
              <Button
                style={{ margin: "10px" }}
                variant="contained"
                size="small"
                color="primary"
                onClick={() => {
                  setSelectedSlot(null);
                  setSlotModalActive(true);
                }}
              >
                Add Opening hours
              </Button>
            </Grid>
          </Tooltip>
        </Grid>
        <Grid item xs={12}>
          <Grid
            container
            style={{
              minHeight: 150,
              maxHeight: 200,
              display: "flex",
              overflowY: "scroll",
            }}
          >
            <Grid item xs={12} className={classes.chipGroup}>
              {slots?.map((slot, i) => {
                const r = getChipMessage(slot);
                return (
                  <Tooltip title={r.expandedMessage}>
                    <Chip
                      key={i}
                      onClick={onSlotEdit(i)}
                      onDelete={onSlotDelete(i)}
                      label={r.body}
                    />
                  </Tooltip>
                );
              })}
            </Grid>
          </Grid>
        </Grid>
      </>
    );
  };
  const StepThree = () => {
    return (
      <>
        <DialogContent>
          <Grid item xs={12}>
            <WidgetComponent traitGroups={traits} onChange={setTraits} />
          </Grid>
          <Tooltip
            title={
              <span style={{ whiteSpace: "pre-line" }}>
                {
                  "Please use this field if there is any additional information from the provider"
                }
              </span>
            }
            placement="bottom-start"
          >
            <Grid item xs={12}>
              <TextField
                fullWidth
                multiline
                rows={5}
                label="Additional information"
                variant="outlined"
                {...bindTraitNotes}
              />
            </Grid>
          </Tooltip>
        </DialogContent>
      </>
    );
  };
  const StepFour = () => {
    return (
      <>
        {!isEditForm && (
          <Grid item xs={12}>
            <div style={{ display: "flex" }}>
              <Typography variant="h6" style={{ marginRight: "10px" }}>
                Activities
              </Typography>
              <ButtonGroup>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleSelectAll}
                >
                  Select all
                </Button>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleDeselectAll}
                >
                  Deselect all
                </Button>
              </ButtonGroup>
            </div>
          </Grid>
        )}
        {!isEditForm && (
          <Grid item xs={12}>
            <Paper variant="outlined" style={{ padding: "1em" }}>
              <ActivitySelector />
            </Paper>
          </Grid>
        )}
        <UploadImages />
      </>
    );
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          padding: "16px 24px",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Typography variant="h6" style={{ flex: "1" }}>
          {isEditForm ? "Edit Branch" : "Add Branch"}
        </Typography>
        <IconButton onClick={onCancel}>
          <Close />
        </IconButton>
      </div>
      <DialogContent>
        <Stepper activeStep={currentStep}>
          <Step>
            <StepLabel>Branch details</StepLabel>
          </Step>
          <Step>
            <StepLabel>Opening hours</StepLabel>
          </Step>
          <Step>
            <StepLabel>Additional questions</StepLabel>
          </Step>
          <Step>
            <StepLabel>Images</StepLabel>
          </Step>
        </Stepper>
        <form className={classes.root} onSubmit={handleSubmit}>
          <Grid container spacing={1}>
            {currentStep === 0 && StepOne()}
            {currentStep === 1 && StepTwo()}
            {currentStep === 2 && StepThree()}
            {currentStep === 3 && StepFour()}
          </Grid>
        </form>

        <DialogActions>
          <Grid container spacing={1} justify="flex-end" alignItems="flex-end">
            <Grid item>
              <Button
                variant="contained"
                disabled={currentStep <= 0 || loading}
                onClick={onPrevClick}
                style={{ marginRight: 8 }}
                color="secondary"
              >
                Prev
              </Button>
              <Button
                onClick={progressStep}
                disabled={loading}
                variant="contained"
                color="primary"
              >
                {loading && (
                  <CircularProgress
                    color="inherit"
                    style={{ marginRight: 8 }}
                    size={20}
                  />
                )}
                {currentStep === 3 ? "Save" : "Next"}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
        <Dialog open={slotModalActive} maxWidth="xs" fullWidth>
          <AddOpeningHourComponent
            data={selectedSlot}
            onUpdate={onSlotUpdate}
            onClose={() => setSlotModalActive(false)}
          />
        </Dialog>
      </DialogContent>
    </>
  );
}
